__turbopack_context__.v({
  "card": "_dGxrq_card",
  "catalog": "_dGxrq_catalog",
  "container": "_dGxrq_container",
  "count": "_dGxrq_count",
  "group": "_dGxrq_group",
  "groupCards": "_dGxrq_groupCards",
  "groupCount--1": "_dGxrq_groupCount--1",
  "groupCount--2": "_dGxrq_groupCount--2",
  "groupCount--3": "_dGxrq_groupCount--3",
  "groupCount--4": "_dGxrq_groupCount--4",
  "groupTitle": "_dGxrq_groupTitle",
  "groupTitleCount": "_dGxrq_groupTitleCount",
  "variant--embed": "_dGxrq_variant--embed",
});
